import { _t } from 'lang';
import FinanceFormLayout from 'layouts/finance-form-layout/FinanceFormLayout';
import AddInvoiceRequestPageContent from 'pages/finance/invoice-request/add-invoice-request/AddInvoiceRequestPageContent';

/**
 * Displays add invoice request page.
 *
 * @see {@link https://www.figma.com/file/X3Zklb3KjOZFu5wAHgGYoH/Toolio---web-Interface?node-id=3128%3A41336&t=u0ATDfjKTGvXjW3S-0 Figma Design}
 */
export default function AddInvoiceRequestPage() {
  return (
    <FinanceFormLayout heading={_t('Create an invoice request')}>
      {(costEstimate) => <AddInvoiceRequestPageContent costEstimate={costEstimate} />}
    </FinanceFormLayout>
  );
}
